import { initialThemeState, IThemeState } from '@myStore/theme/theme.state';
import { EThemeActions, ThemeActions } from '@myStore/theme/theme.actions';

export const themeReducers = (
  state = initialThemeState,
  action: ThemeActions
): IThemeState => {
  switch (action.type) {
    case EThemeActions.SetTheme:
      return {
        ...state,
        theme: action.theme,
      };
    default:
      return state;
  }
};
